import React from "react";

  const partners = [
    { src: "/assets/images/Delhivery.png", alt: "Delhivery", label: "Delhivery" },
    { src: "/assets/images/ecom.png", alt: "ecom", label: "ecom" },
    { src: "/assets/images/bd.jpeg", alt: "bd", label: "bd" },
    { src: "/assets/images/xb.png", alt: "Xpressbess", label: "Xpressbess" },
    { src: "/assets/images/gati.jpg", alt: "Gati", label: "Gati" },
    { src: "/assets/images/sfx.png", alt: "Safexpress", label: "Safexpress" },
    { src: "/assets/images/ama.svg", alt: "AmazonShipping", label: "AmazonShipping" },
    { src: "/assets/images/spice.svg", alt: "Spicejet", label: "Spicejet" },
    { src: "/assets/images/dw.svg", alt: "Dpword", label: "Dpword" }
  ];

export default function PartnersScroll() {
  return (
    <section className="partners-section">
      {/* Header */}
      <div className="partners-header">
        <h2 className="partners-title">
          Forget to Download Order?{" "}
          <span className="partners-title-highlight">Sync with Easy Integration process</span>
        </h2>
        <p className="partners-subtitle">
          Seamlessly integrate with major platforms like Shopify, WooCommerce, Magento,
          Instamojo, PrestaShop, UniCommerce, Amazon, OpenCart, and more.
        </p>
      </div>

      {/* Scrolling logos */}
      <div className="scroll-wrapper">
        <div className="scroll-track">
          {[...partners, ...partners].map((partner, index) => (
            <div key={index} className="logo-card">
              <img src={partner.src} alt={partner.alt} className="logo-img" />
              <span className="logo-label">{partner.alt}</span>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');

        .partners-section {
          font-family: 'DM Sans', sans-serif;
          background-color: #ffffff;
          padding: 56px 0 64px;
          overflow: hidden;
        }

        .partners-header {
          text-align: center;
          max-width: 760px;
          margin: 0 auto 40px;
          padding: 0 24px;
        }

        .partners-title {
          font-size: 1.75rem;
          font-weight: 700;
          color: #1a1a2e;
          margin: 0 0 12px;
          line-height: 1.3;
          letter-spacing: -0.3px;
        }

        .partners-title-highlight {
          color: #1a1a2e;
        }

        .partners-subtitle {
          font-size: 0.975rem;
          color: #2b7de9;
          font-weight: 500;
          line-height: 1.6;
          margin: 0;
        }

        .scroll-wrapper {
          overflow: hidden;
          position: relative;
          width: 100%;
        }

        /* Fade edges */
        .scroll-wrapper::before,
        .scroll-wrapper::after {
          content: '';
          position: absolute;
          top: 0;
          bottom: 0;
          width: 80px;
          z-index: 2;
          pointer-events: none;
        }
        .scroll-wrapper::before {
          left: 0;
          background: linear-gradient(to right, #ffffff, transparent);
        }
        .scroll-wrapper::after {
          right: 0;
          background: linear-gradient(to left, #ffffff, transparent);
        }

        .scroll-track {
          display: flex;
          width: max-content;
          animation: scroll 22s linear infinite;
          gap: 0;
        }

        .scroll-track:hover {
          animation-play-state: paused;
        }

        .logo-card {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 10px;
          margin: 0 14px;
          min-width: 160px;
          height: 96px;
          background-color: #f9f7f2;
          border: 1px solid #ede8de;
          border-radius: 12px;
          padding: 16px 20px;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
          cursor: default;
        }

        .logo-card:hover {
          box-shadow: 0 6px 20px rgba(0,0,0,0.08);
          transform: translateY(-2px);
          background-color: #fff;
        }

        .logo-img {
          max-height: 38px;
          max-width: 110px;
          object-fit: contain;
        }

        .logo-label {
          font-size: 0.72rem;
          font-weight: 600;
          color: #888;
          letter-spacing: 0.3px;
          text-transform: uppercase;
        }

        @keyframes scroll {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
}